import { render, staticRenderFns } from "./PackageForm.vue?vue&type=template&id=3a090b72"
import script from "./PackageForm.vue?vue&type=script&lang=js"
export * from "./PackageForm.vue?vue&type=script&lang=js"
import style0 from "./PackageForm.vue?vue&type=style&index=0&id=3a090b72&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports